import helper from '../../../helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('portaliArticoli');
export const actions = helper.createActions('portaliArticoli', actionTypes);
